import React from "react";
import SupportingText from "../SupportingText";

export default function ArticleCardBodyRow({ name, value }) {
  return (
    <div className="w-full flex py-1">
      <div className="w-1/2 border-r-2 border-grey-lighter">
        <SupportingText textColor="grey-dark">{name}</SupportingText>
      </div>
      <div className="w-1/2 pl-3">
        <SupportingText textColor="grey-darkest">{value}</SupportingText>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/ArticleCardBodyRow/ArticleCardBodyRow.js